import React, { FC } from 'react';

import { useAppContext } from '../../../store/appContext';

export const BeforeReductionPrice: FC<{
  formattedPriceAfterReduction: string;
  reductionPercentage?: number;
  style: {
    fontSize: string;
    marginBottom: string;
    spaceBeforeSaleText: string;
  };
}> = ({ formattedPriceAfterReduction, reductionPercentage, style }) => {
  const { freeShipping: showSale } = useAppContext();
  return reductionPercentage && reductionPercentage !== 0 ? (
    <div className="price-reduction-info">
      <span className="non-reduced-price">{formattedPriceAfterReduction}</span>
      <span className="sale-info">{showSale ? 'Sale' : ` ${reductionPercentage}% OFF`}</span>

      <style jsx>{`
        .price-reduction-info {
          width: 100%;
          margin-bottom: ${style.marginBottom};
          line-height: 1;
        }

        .non-reduced-price {
          font-size: ${style.fontSize};
          display: inline-block;
          color: #999;
          text-decoration: line-through;
          margin-right: ${style.spaceBeforeSaleText};
        }
        .sale-info {
          display: inline-block;
          font-size: ${style.fontSize};
          color: #f25c5e;
        }
      `}</style>
    </div>
  ) : null;
};
